<script lang="ts" setup="">
defineProps<{ title: string, subtitle?: string }>()
</script>

<template>
  <div class="flex flex-col gap-m items-center py-s">
    <div class="flex flex-col gap-3xs text-center">
      <h4 class="title-s" v-text="title" />
      <span v-if="subtitle" class="text-secondary" v-text="subtitle" />
    </div>
    <div v-if="$slots.default" class="title-s text-blurple-400 text-center">
      <slot />
    </div>
  </div>
</template>
